<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="90%"
      append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
      top="8vh"
    >
      <span slot="title" style="font-size: 20px">
        {{ title }}
        <el-tooltip placement="right">
          <div slot="content">字符串和数字的比较类型为【包含，不包含】时，值内容要以英文逗号隔开</div>
          <i class="el-icon-question" />
        </el-tooltip>
      </span>
      <div style="position: relative; height: 450px; overflow: auto">
        <div style="position: absolute; z-index: 2">
          <form data-vv-scope="form1" v-form>
            <table class="table-list custom_condition_tab table" :style="tab.style" v-for="tab in tabList" :key="tab.indexStr">
              <tbody>
                <tr>
                  <td style="width: 220px">
                    <el-select
                      v-model="tab.condition_field"
                      :validate="{ required: true }"
                      :filterable="true"
                      style="width: 200px"
                      @change="setFieldOtherInfo(this, tab, 1)"
                    >
                      <el-option v-for="item in varTree" :key="item.name" :value="item.name" :label="item.desc"></el-option>
                    </el-select>
                  </td>
                  <td style="width: 100px">
                    <el-select v-model="tab.condition_operator" style="width: 100px">
                      <el-option label="等于" value="EQ"></el-option>
                      <el-option label="不等于" value="NE"></el-option>
                      <el-option v-if="tab.condition_type === 'number' || tab.condition_type === 'date'" label="大于" value="GT"></el-option>
                      <el-option v-if="tab.condition_type === 'number' || tab.condition_type === 'date'" label="大于等于" value="GE"></el-option>
                      <el-option v-if="tab.condition_type === 'number' || tab.condition_type === 'date'" label="小于" value="LT"></el-option>
                      <el-option v-if="tab.condition_type === 'number' || tab.condition_type === 'date'" label="小于等于" value="LE"></el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="包含" value="IN"></el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="不包含" value="NOTIN"></el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="相似" value="LIKE"> </el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="不相似" value="NOTLIKE"> </el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="左相似" value="LKS"> </el-option>
                      <el-option v-if="tab.condition_type === 'varchar' || tab.condition_type === 'clob'" label="右相似" value="LKE"> </el-option>
                      <el-option label="为空" value="EMPTY"> </el-option>
                      <el-option label="不为空" value="NOTEMPTY"> </el-option>
                    </el-select>
                  </td>
                  <td style="width: 100px">
                    <el-select
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      v-model="tab.condition_ctrl_type"
                      class="selected_search"
                      @change="ctrlTypeChange(tab)"
                    >
                      <el-option label="值" value="VALUE"></el-option>
                      <el-option label="模型" value="MODEL"></el-option>
                      <el-option label="字典" value="DICT" v-if="tab.condition_type !== 'date'"></el-option>
                      <el-option label="枚举" value="ENUM" v-if="tab.condition_type !== 'date'"></el-option>
                    </el-select>
                  </td>
                  <td v-show="tab.condition_ctrl_type === 'MODEL'" style="width: 220px">
                    <eco-select
                      v-model="tab.condition_ctrl_value"
                      :validate="{ required: true }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      style="width: 200px"
                      :filterable="true"
                      :clearable="true"
                      :collapse-tags="true"
                      :multiple="tab.condition_operator === 'IN' || tab.condition_operator === 'NOTIN'"
                      :options="varTree"
                      :props="{ key: 'name', value: 'desc' }"
                      @change="setFieldOtherInfo(this, tab, 2)"
                    />
                  </td>
                  <!--普通文本框-->
                  <td v-if="tab.condition_ctrl_type === 'VALUE' && tab.condition_type !== 'date'" style="width: 220px">
                    <eco-input
                      style="width: 203px"
                      v-model="tab.condition_ctrl_value"
                      :validate="{ required: false }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                    />
                  </td>
                  <!--日期-->
                  <td v-if="tab.condition_ctrl_type === 'VALUE' && tab.condition_type === 'date'" style="width: 220px">
                    <eco-date
                      v-model="tab.condition_ctrl_value"
                      style="width: 215px"
                      :validate="{ required: true }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      :format="tab.format"
                      :showDate="false"
                    />
                  </td>
                  <!--数据字典-->
                  <td v-if="tab.condition_ctrl_type === 'DICT'" style="width: 350px">
                    字典：
                    <eco-select
                      v-model="tab.condition_extend"
                      placeholder="请选择"
                      :filterable="true"
                      :clearable="true"
                      :options="allDataDict"
                      :props="{ key: 'key', value: 'name' }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      style="width: 130px"
                      @change="selectDict(tab)"
                    />
                    值：
                    <new-select
                      v-model="tab.condition_ctrl_value"
                      placeholder="请选择"
                      :filterable="true"
                      :clearable="true"
                      :collapse-tags="true"
                      :multiple="tab.condition_operator === 'IN' || tab.condition_operator === 'NOTIN'"
                      :dic-key="tab.condition_extend"
                      :defineProps="{ key: 'key', value: 'name' }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      style="width: 130px"
                      collapse-tags
                    />
                  </td>
                  <!--枚举-->
                  <td v-if="tab.condition_ctrl_type === 'ENUM'" style="width: 350px">
                    枚举：
                    <eco-select
                      v-model="tab.condition_extend"
                      placeholder="请选择"
                      :filterable="true"
                      :clearable="true"
                      :options="allEnumerate"
                      :props="{ key: 'name', value: 'desc' }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      style="width: 130px"
                      @change="selectEnumerate(tab)"
                    />
                    值：
                    <new-select
                      v-model="tab.condition_ctrl_value"
                      placeholder="请选择"
                      :filterable="true"
                      :clearable="true"
                      :collapse-tags="true"
                      :multiple="tab.condition_operator === 'IN' || tab.condition_operator === 'NOTIN'"
                      :enum-key="tab.condition_extend"
                      :defineProps="{ key: 'value', value: 'label' }"
                      :disabled="tab.condition_operator === 'EMPTY' || tab.condition_operator === 'NOTEMPTY'"
                      style="width: 130px"
                      collapse-tags
                    />
                  </td>
                  <td style="width: 60px">
                    <el-button @click="removeCondition(tab.indexStr)" size="mini" icon="el-icon-delete"></el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </form>
          <div class="labelrag" :style="branch.style" v-for="(branch, $index) in branchList" :key="branch.indexStr">
            <el-select v-model="branch.newconditional_relation" class="selected_search" @change="changecondition($index)">
              <el-option label="并且" value="AND"></el-option>
              <el-option label="或者" value="OR"></el-option>
              <el-option label="添加条件" value="3"></el-option>
              <el-option label="添加联合条件" value="4" v-if="branch.condition !== 'noAdd'"></el-option>
              <el-option label="删除" value="5" v-if="branch.condition != 'noDel'"></el-option>
            </el-select>
          </div>
        </div>
        <div v-html="svgHtml" style="position: absolute; z-index: 1; width: 500px; height: 100%"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-input v-if="bindForm" type="textarea" :rows="2" readonly v-model="scriptDes"></el-input>
        <el-input v-if="bindForm" type="textarea" :rows="2" readonly v-model="scriptStr"></el-input>
        <div>
          <el-button v-if="bindForm" type="primary" @click="previewCondition(false)" size="medium">预览表达式</el-button>
          <el-button v-if="bindForm" type="primary" @click="previewCondition(true)" size="medium">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/eco-ui-util.js'
import dictUtils from '@/utils.js'
import newSelect from '@/components/tenant/rule/component/newSelect.vue'

export default {
  components: {
    newSelect
  },
  props: ['defId', 'value'],
  data() {
    return {
      userConditionTab: 'first',
      dialogVisible: false,
      title: '条件选择器',
      conditionList: [],
      conditionObj: {},
      conditionName: '',
      pathList: [],
      data: {},
      branchList: [],
      tabList: [],
      Tree: [],
      svgHeight: '400px',
      defaultCondition: {
        condition_field: '',
        condition_operator: '',
        condition_type: '',
        condition_ctrl_value: '',
        condition_ctrl_type: 'VALUE',
        condition_extend: ''
      },
      Mleft: 50, //初始左边距50
      Mtop: 20, //初始上边距40
      XIncase: 100, //x轴递增数值70
      YIncase: 50, //y轴递增数据50
      svgHtml: '',
      varTree: [],
      filedsObj: {},
      scriptStr: '',
      scriptDes: '',
      bindForm: true,
      dictOptions: [],
      enumerateOptions: []
    }
  },
  computed: mapState({
    allDataDict: (state) => state.user.allDataDict,
    allEnumerate: (state) => state.user.allEnumerate
  }),
  methods: {
    //根据条件数组构建条件分支界面
    buildConditionTree(data) {
      let pathArr = []
      let tableArr = []
      let branchArr = []
      this.buildData(data, pathArr, tableArr, branchArr)
      this.pathList = pathArr
      this.branchList = branchArr
      this.tabList = tableArr
      //取路径最后一条数据，因为该条数据的高度距离顶部最大
      let lastPath = pathArr[pathArr.length - 1]
      let lastIndexArr = []
      if (lastPath) lastIndexArr = lastPath.split(',')
      //取最后一个坐标点。终点纵坐标为整个svg中最大的纵坐标
      let lastYIndex = lastIndexArr[lastIndexArr.length - 1]
      //设置svg的高度为最大纵坐标+100，从而实现svg页面高度自适应
      if (lastYIndex) {
        this.svgHeight = parseInt(lastYIndex) + 50 + 'px'
      }
      this.createSvgHtml(pathArr)
    },
    //构建svg图形页面
    createSvgHtml(pathArr) {
      this.svgHtml = ''
      var html =
        '<svg height="' + this.svgHeight + '" version="1.1" width="692" xmlns="http://www.w3.org/2000/svg" style="overflow: hidden; position: relative;">'
      for (var i = 0; i < pathArr.length; i++) {
        html += '<path fill="none" stroke="#787878"' + 'd="' + this.pathList[i] + '" style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0);"></path>'
      }
      html += '</svg>'
      this.svgHtml = html
    },
    changecondition(index) {
      var oldVal = this.branchList[index].oldconditional_relation
      var newVal = this.branchList[index].newconditional_relation
      if (newVal == '3' || newVal == '4' || newVal == '5') {
        this.branchList[index].newconditional_relation = this.branchList[index].oldconditional_relation
        var indexStr = this.branchList[index].indexStr
        if (newVal == '3') {
          this.addCondition(indexStr)
        } else if (newVal == '4') {
          this.addUnionCondition(indexStr)
        } else {
          this.$confirm('确定要删除此联合条件及其下属的所有子条件吗？', '提示', {
            cancelButtonText: '取消',
            confirmButtonText: '确定',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.removeCondition(indexStr)
          })
        }
      } else {
        this.branchList[index].oldconditional_relation = this.branchList[index].newconditional_relation
        var indexStr = this.branchList[index].indexStr
        var indexArr = indexStr.split(',')
        if (indexStr == 'root') {
          this.conditionObj.conditional_relation = newVal
        } else if (indexArr.length == 1) {
          this.conditionObj.condition[indexStr].conditional_relation = newVal
        } else if (indexArr.length == 2) {
          this.conditionObj.condition[indexArr[0]].condition[indexArr[1]].conditional_relation = newVal
        }
      }
    },
    //添加一个联合
    addCondition(indexStr) {
      var data = this.conditionObj.condition
      if (indexStr == 'root') {
        data.push(JSON.parse(JSON.stringify(this.defaultCondition)))
      } else {
        var indexArr = []
        if (indexStr) indexArr = indexStr.split(',')
        for (var i = 0; i < data.length; i++) {
          if (indexArr.length > 0 && i == indexArr[0]) {
            if (indexArr.length > 1) {
              for (var j = 0; j < data[i].condition.length; j++) {
                if (j == indexArr[1]) {
                  data[i].condition[j].condition.push(JSON.parse(JSON.stringify(this.defaultCondition)))
                  break
                }
              }
            } else {
              data[i].condition.push(JSON.parse(JSON.stringify(this.defaultCondition)))
            }
            break
          }
        }
      }
      this.conditionObj.condition = data
      this.buildConditionTree(this.conditionObj)
    },
    removeCondition(indexStr) {
      var indexArr = []
      if (indexStr) indexArr = indexStr.split(',')
      if (indexArr.length > 0) {
        var data = this.conditionObj.condition
        for (var i = 0; i < data.length; i++) {
          if (i == indexArr[0]) {
            if (indexArr.length > 1) {
              for (var j = 0; j < data[i].condition.length; j++) {
                if (j == indexArr[1]) {
                  if (indexArr.length > 2) {
                    for (var z = 0; z < data[i].condition[j].condition.length; z++) {
                      if (z == indexArr[2]) {
                        data[i].condition[j].condition.splice(z, 1)
                        break
                      }
                    }
                  } else {
                    data[i].condition.splice(j, 1)
                  }
                  break
                }
              }
            } else {
              data.splice(i, 1)
            }
            break
          }
        }
        this.conditionObj.condition = data
        this.buildConditionTree(this.conditionObj)
      }
    },
    //添加一个联合条件条件
    addUnionCondition(indexStr) {
      var data = this.conditionObj.condition
      if (indexStr == 'root') {
        data.push({ conditional_relation: 'OR', condition: [] })
      } else {
        var indexArr = []
        if (indexStr) indexArr = indexStr.split(',')
        for (var i = 0; i < data.length; i++) {
          if (indexArr.length > 0 && i == indexArr[0]) {
            if (indexArr.length > 1) {
              for (var j = 0; j < data[i].condition.length; j++) {
                if (j == indexArr[1]) {
                  data[i].condition[j].condition.push({
                    conditional_relation: 'OR',
                    condition: []
                  })
                  break
                }
              }
            } else {
              data[i].condition.push({ conditional_relation: 'OR', condition: [] })
            }
            break
          }
        }
      }
      this.conditionObj.condition = data
      this.buildConditionTree(this.conditionObj)
    },
    buildData(conditionData, pathArr, tableArr, branchArr) {
      let curYIndex = 0
      let data = conditionData.condition
      //算三级节点总共分支个数
      let yIncaseNum = this.getyIncaseNum(conditionData.condition) > 1 ? this.getyIncaseNum(conditionData.condition) : 1
      //第一个节点 this.Mtop 最后一个节点Mtop+this.YIncase*（yIncaseNum-1）
      let startY1 = (this.Mtop * 2 + this.YIncase * (yIncaseNum - 1)) / 2

      branchArr.push({
        newconditional_relation: conditionData.conditional_relation,
        oldconditional_relation: conditionData.conditional_relation,
        style: 'left:' + (this.Mleft - 35) + 'px; top:' + (startY1 - 15) + 'px',
        indexStr: 'root',
        condition: 'noDel'
      })
      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].condition_ctrl_type === 'DICT') {
          this.selectDict(data[i], false)
        }
        if (data[i] && data[i].condition_ctrl_type === 'ENUM') {
          this.selectEnumerate(data[i], false)
        }
        if (data[i].condition) {
          var curchildNum = this.getyIncaseNum(data[i].condition)
          //如果该节点，没有分支条件，则保留节点
          var isEmpty0 = false
          if (curchildNum < 1) {
            curchildNum = 1
            isEmpty0 = true
          }
          //计算一级节点和该节点的连线
          var startY2 = (this.Mtop * 2 + this.YIncase * (2 * curYIndex + curchildNum - 1)) / 2
          var path =
            'M' +
            this.Mleft +
            ',' +
            startY1 +
            'C' +
            this.Mleft +
            ',' +
            startY2 +
            ',' +
            this.Mleft +
            ',' +
            startY2 +
            ',' +
            (this.Mleft + this.XIncase) +
            ',' +
            startY2
          pathArr.push(path)
          branchArr.push({
            newconditional_relation: data[i].conditional_relation,
            oldconditional_relation: data[i].conditional_relation,
            style: 'left:' + (this.Mleft + this.XIncase - 35) + 'px; top:' + (startY2 - 15) + 'px',
            indexStr: '' + i
          })
          if (isEmpty0) curYIndex++

          for (var j = 0; j < data[i].condition.length; j++) {
            if (data[i].condition[j] && data[i].condition[j].condition_ctrl_type === 'DICT') {
              this.selectDict(data[i].condition[j], false)
            }
            if (data[i].condition[j] && data[i].condition[j].condition_ctrl_type === 'ENUM') {
              this.selectEnumerate(data[i].condition[j], false)
            }
            //如果第三级节点有分支，则计算分支
            if (data[i].condition[j].condition) {
              //计算改节点分支个数
              let curchildNum2 = this.getyIncaseNum(data[i].condition[j].condition)
              //如果该节点，没有分支条件，则保留节点,默认其占一行
              let isEmpty = false
              if (curchildNum2 < 1) {
                curchildNum2 = 1
                isEmpty = true
              }
              // 改分支第一个节点纵坐标= this.Mtop+this.YIncase*curYIndex  上一个节点纵坐标加上递增值
              // 改分支最后节点纵坐标=改分支第一个节点纵坐标 +计算改节点分支个数*y递增值 this.Mtop+this.YIncase*curYIndex+this.YIncase*(curchildNum2-1)
              // 计算改节点的纵坐标。（改分支第一个节点纵坐标+该分支的最后一个纵坐标）/2
              // 该节点起始点纵坐标=  this.Mtop+this.YIncase*curYIndex+ this.Mtop+this.YIncase*curYIndex+this.YIncase*(curchildNum2-1)
              let startY3 = (this.Mtop * 2 + this.YIncase * (2 * curYIndex + curchildNum2 - 1)) / 2
              //改分支指引线的终点的纵坐标等于startY2
              let path =
                'M' +
                (this.Mleft + this.XIncase) +
                ',' +
                startY2 +
                'C' +
                (this.Mleft + this.XIncase) +
                ',' +
                startY3 +
                ',' +
                (this.Mleft + this.XIncase) +
                ',' +
                startY3 +
                ',' +
                (this.Mleft + this.XIncase * 2) +
                ',' +
                startY3
              pathArr.push(path)
              branchArr.push({
                newconditional_relation: data[i].condition[j].conditional_relation,
                oldconditional_relation: data[i].condition[j].conditional_relation,
                style: 'left:' + (this.Mleft + this.XIncase * 2 - 35) + 'px; top:' + (startY3 - 15) + 'px',
                indexStr: i + ',' + j,
                condition: 'noAdd'
              })
              if (isEmpty) {
                curYIndex++
              }
              for (let z = 0; z < data[i].condition[j].condition.length; z++) {
                let obj = data[i].condition[j].condition[z]
                if (obj && obj.condition_ctrl_type === 'DICT') {
                  this.selectDict(obj, false)
                }
                if (obj && obj.condition_ctrl_type === 'ENUM') {
                  this.selectEnumerate(obj, false)
                }
                obj.style = 'left:' + (this.Mleft + this.XIncase * 3) + 'px; top:' + (this.Mtop + this.YIncase * curYIndex - 19) + 'px'
                obj.indexStr = i + ',' + j + ',' + z
                tableArr.push(obj)
                //改分支下所有节点的起始纵坐标为startY3，终点纵坐标根据该节点位置决定
                let path =
                  'M' +
                  (this.Mleft + this.XIncase * 2) +
                  ',' +
                  startY3 +
                  'C' +
                  (this.Mleft + this.XIncase * 2) +
                  ',' +
                  (this.Mtop + this.YIncase * curYIndex) +
                  ',' +
                  (this.Mleft + this.XIncase * 2) +
                  ',' +
                  (this.Mtop + this.YIncase * curYIndex) +
                  ',' +
                  (this.Mleft + this.XIncase * 3) +
                  ',' +
                  (this.Mtop + this.YIncase * curYIndex)
                pathArr.push(path)
                curYIndex++
              }
            } else {
              //第二级节点没有分支
              let obj = data[i].condition[j]
              obj.style = 'left:' + (this.Mleft + this.XIncase * 2) + 'px; top:' + (this.Mtop + this.YIncase * curYIndex - 19) + 'px'
              obj.indexStr = i + ',' + j
              tableArr.push(obj)
              //计算改分支的路径。因为是第二节点。startY2
              let path =
                'M' +
                (this.Mleft + this.XIncase) +
                ',' +
                startY2 +
                'C' +
                (this.Mleft + this.XIncase) +
                ',' +
                (this.Mtop + this.YIncase * curYIndex) +
                ',' +
                (this.Mleft + this.XIncase) +
                ',' +
                (this.Mtop + this.YIncase * curYIndex) +
                ',' +
                (this.Mleft + this.XIncase * 2) +
                ',' +
                (this.Mtop + this.YIncase * curYIndex)
              pathArr.push(path)
              curYIndex++
            }
          }
        } else {
          let obj = data[i]
          obj.style = 'left:' + (this.Mleft + this.XIncase) + 'px; top:' + (this.Mtop + this.YIncase * curYIndex - 19) + 'px'
          obj.indexStr = '' + i
          tableArr.push(obj)
          let path =
            'M' +
            this.Mleft +
            ',' +
            startY1 +
            'C' +
            this.Mleft +
            ',' +
            (this.Mtop + this.YIncase * curYIndex) +
            ',' +
            this.Mleft +
            ',' +
            (this.Mtop + this.YIncase * curYIndex) +
            ',' +
            (this.Mleft + this.XIncase) +
            ',' +
            (this.Mtop + this.YIncase * curYIndex)
          pathArr.push(path)
          curYIndex++
        }
      }
    },
    //获取条件总数
    getyIncaseNum(data) {
      var sum = 0
      for (var i = 0; i < data.length; i++) {
        if (data[i].condition && data[i].condition.length > 0) {
          for (var j = 0; j < data[i].condition.length; j++) {
            if (data[i].condition[j].condition && data[i].condition[j].condition.length > 0) {
              for (var z = 0; z < data[i].condition[j].condition.length; z++) {
                sum++
              }
            } else {
              sum++
            }
          }
        } else {
          sum++
        }
      }
      return sum
    },
    showDialog: function (conditionFields, conditionDetail) {
      let this_ = this
      this.svgHtml = ''
      this.scriptStr = ''
      this.scriptDes = ''
      this_.buildVarTree(conditionFields)
      if (conditionDetail && conditionDetail.conditional_relation) {
        this_.conditionObj = conditionDetail
      } else {
        this_.conditionObj = { conditional_relation: 'AND', condition: [] }
      }
      this_.buildConditionTree(this_.conditionObj)
      this_.dialogVisible = true
    },
    buildVarTree(treeData) {
      var treeArr = []
      for (var i = 0, t; (t = treeData[i++]); ) {
        //处理表单变量
        this.filedsObj[t.name] = t
        treeArr.push(t)
      }
      if (treeArr.length > 0) {
        this.varTree = treeArr
      } else {
        this.$message.warning('请先绑定业表单')
        this.bindForm = false
      }
    },
    setFieldOtherInfo(ele, tab, type) {
      let selectFiled = this.filedsObj[tab.condition_field]
      if (type === 1) {
        tab.condition_type = selectFiled.dataType
        tab.format = selectFiled.format
        tab.condition_field_name = selectFiled.desc
        tab.condition_ctrl_value = ''
        tab.condition_operator = ''
      } else {
        tab.condition_field_name = selectFiled.desc
      }
    },
    IsShowfiled(m, tab) {
      if (!tab) return false
      if (m.pathStr == tab.condition_field) {
        return false
      } else if (m.condition_type != tab.condition_type) {
        return false
      }
      return true
    },
    previewCondition(isConfirm) {
      console.log(this.tabList, 56464)
      utils
        .validateForm(this, 'form1')
        .then((r) => {
          if (!this.conditionObj) return
          var data = this.getConditionStr(this.conditionObj)
          data.conditionObj = JSON.stringify(this.conditionObj)
          this.scriptStr = data.conditionString
          this.scriptDes = data.conditionDes
          if (isConfirm) {
            this.$emit('input', this.scriptStr)
            this.$emit('onConfirm', data.conditionObj)
            this.dialogVisible = false
          }
        })
        .catch((items) => {
          this.$message.error(`还有内容未填写，无法生成表表达式。`)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getConditionStr(obj) {
      var returnData = {}
      if (!obj || !obj.condition || obj.condition.length === 0) return returnData
      var data = obj.condition
      var res = ''
      var desString = ''
      for (var i = 0; i < data.length; i++) {
        //第一节点的表达式
        var curcondStr1 = ''
        var curcondDes1 = ''
        //如果第一节点有分支则计算
        if (data[i].condition && data[i].condition.length === 0) {
          return
        } else if (data[i].condition && data[i].condition.length > 0) {
          curcondStr1 += '('
          curcondDes1 += '('
          for (var j = 0; j < data[i].condition.length; j++) {
            //第二节点的表达式
            var curcondStr2 = ''
            var curcondDes2 = ''
            //如果第三级节点有分支，则计算分支
            if (data[i].condition[j].condition && data[i].condition[j].condition.length === 0) {
              return
            } else if (data[i].condition[j].condition && data[i].condition[j].condition.length > 0) {
              curcondStr2 += '('
              curcondDes2 += '('
              var curcondStr3 = ''
              var curcondDes3 = ''
              for (var z = 0; z < data[i].condition[j].condition.length; z++) {
                curcondStr3 = this.getConditionStrByObj(data[i].condition[j].condition[z])
                curcondDes3 = this.getConditionStrByObj(data[i].condition[j].condition[z], 'des')
                if (curcondStr3 != '') {
                  //循环拼接第三节点的条件
                  if (z == 0) {
                    //第一个不拼接运算符
                    curcondStr2 += curcondStr3
                    curcondDes2 += curcondDes3
                  } else {
                    curcondStr2 += this.getconditional_relation(data[i].condition[j].conditional_relation) + curcondStr3
                    curcondDes2 += this.getconditional_relation(data[i].condition[j].conditional_relation) + curcondDes3
                  }
                }
              }
              curcondStr2 += ')'
              curcondDes2 += ')'
            } else if (data[i].condition[j].condition_field) {
              //第二节点没有分只
              curcondStr2 = this.getConditionStrByObj(data[i].condition[j])
              curcondDes2 = this.getConditionStrByObj(data[i].condition[j], 'des')
            }
            if (curcondStr2 != '') {
              //循环拼接第二节点的条件
              if (j == 0) {
                //第一个不拼接运算符
                curcondStr1 += curcondStr2
                curcondDes1 += curcondDes2
              } else {
                curcondStr1 += this.getconditional_relation(data[i].conditional_relation) + curcondStr2
                curcondDes1 += this.getconditional_relation(data[i].conditional_relation) + curcondDes2
              }
            }
          }
          curcondStr1 += ')'
          curcondDes1 += ')'
        } else if (data[i].condition_field) {
          //第一节点没有分只
          curcondStr1 = this.getConditionStrByObj(data[i])
          curcondDes1 = this.getConditionStrByObj(data[i], 'des')
        }
        if (curcondStr1 != '') {
          //循环拼接第一节点的条件
          if (i == 0) {
            //第一个不拼接运算符
            res += curcondStr1
            desString += curcondDes1
          } else {
            res += this.getconditional_relation(obj.conditional_relation) + curcondStr1
            desString += this.getconditional_relation(obj.conditional_relation) + curcondDes1
          }
        }
      }
      returnData.conditionString = res
      returnData.conditionDes = desString
      return returnData
    },
    getconditional_relation(str) {
      var res = ''
      switch (str) {
        case 'AND':
          res = ' && '
          break
        case 'OR':
          res = ' || '
          break
      }
      return res
    },
    getConditionStrByObj(obj, type) {
      console.info(obj)
      var res = ''
      switch (obj.condition_type) {
        case 'varchar':
          res = this.buildStringCondition(obj, type)
          break
        case 'date':
          res = this.buildDateCondition(obj, type)
          break
        case 'number':
          res = this.buildIntCondition(obj, type)
          break
      }
      return res
    },
    buildDateCondition(obj, type) {
      var value = obj.condition_ctrl_value
      var valueDes = ''
      var property = obj.condition_field
      let res = ''
      if (obj.condition_ctrl_type === 'VALUE') {
        value = '"' + obj.condition_ctrl_value + '"'
        valueDes = value
      } else {
        valueDes = obj.condition_field_name
      }
      if (type === 'des') {
        property = obj.condition_field_name
      }
      switch (obj.condition_operator) {
        case 'EQ':
          res = property + ' == ' + value
          break
        case 'NE':
          res = property + ' != ' + value
          break
        case 'GT':
          res = property + ' > ' + value
          break
        case 'LT':
          res = property + ' < ' + value
          break
        case 'EMPTY':
          res = '(' + property + " == null || '' == " + property + ')'
          break
        case 'NOTEMPTY':
          res = '(' + property + " != null && '' ！= " + property + ')'
          break
      }

      return res
    },
    buildStringCondition(obj, type) {
      var value = obj.condition_ctrl_value
      var valueDes = ''
      var property = obj.condition_field
      let res = ''
      if (obj.condition_ctrl_type === 'VALUE') {
        value = '"' + obj.condition_ctrl_value + '"'
        valueDes = value
      } else {
        valueDes = obj.condition_field_name
      }
      if (type === 'des') {
        property = obj.condition_field_name
      }
      switch (obj.condition_operator) {
        case 'EQ':
          res = property + ' == ' + value
          break
        case 'NE':
          res = property + ' != ' + value
          break
        case 'GT':
          res = property + ' > ' + value
          break
        case 'LT':
          res = property + ' < ' + value
          break
        case 'LIKE':
          res = property + ' LIKE %' + value + '%'
          break
        case 'LKS':
          res = property + ' LIKE ' + value + '%'
          break
        case 'LKE':
          res = property + ' LIKE %' + value
          break
        case 'IN':
          res = property + ' IN (' + value + ')'
          break
        case 'NOTIN':
          res = property + ' NOT IN (' + value + ')'
          break
        case 'EMPTY':
          res = '(' + property + " == null || '' == " + property + ')'
          break
        case 'NOTEMPTY':
          res = '(' + property + " != null && '' ！= " + property + ')'
          break
      }

      return res
    },
    buildIntCondition(obj, type) {
      var value = obj.condition_ctrl_value
      var valueDes = ''
      var property = obj.condition_field
      if (obj.condition_ctrl_type === 'VALUE') {
        value = obj.condition_ctrl_value
        valueDes = value
      } else {
        valueDes = obj.condition_field_name
      }
      if (type === 'des') {
        property = obj.condition_field_name
      }
      var res = ''
      switch (obj.condition_operator) {
        case 'EQ':
          res = property + ' == ' + value
          break
        case 'NE':
          res = property + ' != ' + value
          break
        case 'GT':
          res = property + ' > ' + value
          break
        case 'LT':
          res = property + ' < ' + value
          break
        case 'GE':
          res = property + ' >= ' + value
          break
        case 'LE':
          res = property + ' <= ' + value
          break
        case 'IN':
          res = property + ' IN (' + value + ')'
          break
        case 'NOTIN':
          res = property + ' NOT IN (' + value + ')'
          break
        case 'EMPTY':
          res = '(' + property + " == null || '' == " + property + ')'
          break
        case 'NOTEMPTY':
          res = '(' + property + " != null && '' ！= " + property + ')'
          break
      }
      return res
    },
    handleClose: function () {
      utils
        .validateForm(this, 'form1')
        .then((r) => {
          this.dialogVisible = false
        })
        .catch((items) => {
          this.$message.error(`还有内容未填写，无法生成表表达式。`)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectDict(tab, isSelect = true) {
      if (isSelect) {
        tab.condition_ctrl_value = ''
      }
      // console.log(tab.condition_extend, 56464)
      // tab.dictOptions = dictUtils.findDictList(tab.condition_extend, this.allDataDict)
    },
    selectEnumerate(tab, isSelect = true) {
      if (isSelect) {
        tab.condition_ctrl_value = ''
      }
      this.enumerateOptions = dictUtils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: tab.condition_extend,
        allData: this.allEnumerate
      })
    },
    ctrlTypeChange(tab) {
      tab.condition_ctrl_value = ''
      tab.condition_extend = ''
    }
  },
  created() {
    this.$validator = this.$root.$validator
  }
}
</script>

<style scoped>
.dialog-footer {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
div >>> .el-dialog__body {
  padding: 10px;
}

.table > thead > tr > th,
.table > thead > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #e7eaec;
  border-left: 1px solid #e7eaec;
  line-height: 1.42857;
  vertical-align: middle;
  padding: 4px;
}

.table > tbody > tr > td {
  text-align: center;
}
.table {
  border-bottom: 1px solid #e7eaec;
  border-right: 1px solid #e7eaec;
  border-spacing: 0;
}
.table >>> .el-button {
  padding: 6px 8px;
}
div >>> .el-tabs__content {
  height: 450px;
  overflow: auto;
}
.labelrag {
  padding: 0.2em 0.2em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  background-color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 12px;
  width: 70px;
  line-height: 20px;
  border: solid 1px;
  position: absolute;
  z-index: 3;
}
div >>> .labelrag > .selected_search {
  width: 60px;
  border: none;
  outline: none;
  height: 22px;
}
div >>> .labelrag > .el-select > .el-input > .el-input__inner {
  padding: 0px;
  border: none;
  height: 26px;
}
.custom_condition_tab {
  width: 950px;
  position: absolute;
}
.inputs >>> .el-form-item__error {
  display: none;
}

div >>> [aria-invalid='true'] .el-input .el-input__inner {
  border-color: #f56c6c;
}

.form-empty {
  position: absolute;
  text-align: center;
  width: 300px;
  font-size: 20px;
  top: 200px;
  margin-left: 400px;
  color: #ccc;
}
</style>

<style>
.el-select__tags {
  flex-wrap: nowrap !important;
}
</style>
